const SuperAdminHomePage = () => {
  return <div>Home Ji</div>;
};

export default SuperAdminHomePage;
